
import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initPostHog } from './lib/posthog'
import { storeInitialUrl } from './lib/analytics'

// Initialize PostHog
initPostHog();

// Store initial URL for first-touch attribution
storeInitialUrl();

// Gestionnaire d'erreur général
window.addEventListener('error', (event) => {
  // Supprimer l'erreur interne YouTube API connue
  if (event.message?.includes('this.api.logApiCall is not a function') || 
      event.filename?.includes('youtube.com')) {
    event.preventDefault();
    return false;
  }
  
  console.error('Global error caught:', event.error || event.message);
  
  // Empêcher les erreurs des scripts externes de planter l'application
  if (!event.filename || event.message === 'Script error.') {
    event.preventDefault();
    return false;
  }
});

// Fonction d'initialisation de l'application
function initializeApp() {
  try {
    const rootElement = document.getElementById("root");
    if (rootElement) {
      const app = (
        <React.StrictMode>
          <App />
        </React.StrictMode>
      );
      createRoot(rootElement).render(app);
      console.log("Application rendered successfully");
    } else {
      console.error("Root element not found");
      const fallbackRoot = document.createElement("div");
      fallbackRoot.id = "root";
      document.body.appendChild(fallbackRoot);
      createRoot(fallbackRoot).render(
        <React.StrictMode>
          <App />
        </React.StrictMode>
      );
      console.log("Application rendered with fallback root");
    }
  } catch (error) {
    console.error("Error rendering application:", error);
    
    // Afficher une interface de secours au lieu d'un écran vide
    try {
      const rootElement = document.getElementById("root") || document.body;
      if (rootElement) {
        rootElement.innerHTML = `
          <div style="padding: 20px; font-family: sans-serif;">
            <h1>Something went wrong</h1>
            <p>The application couldn't load properly. Please try refreshing the page.</p>
          </div>
        `;
      }
    } catch (fallbackError) {
      console.error("Failed to render fallback UI:", fallbackError);
    }
  }
}

// Utiliser setTimeout pour s'assurer que nos gestionnaires d'erreurs sont en place avant l'initialisation
setTimeout(initializeApp, 0);
